module.exports = __webpack_public_path__ + "static/media/grainger-logo-white.8e5ae52c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/grainger-logo-white.png
// module id = 61
// module chunks = 0